import { Trans } from 'react-i18next'

import theScreamPNG from '~/assets/images/art/the-scream.png'
import theScreamWEBP from '~/assets/images/art/the-scream.webp'
import { ImageLayoutStyles as PS } from '~/pages/anatomy/quizBinaryChoice/libs/styles/imageLayout'
import { FactCaption } from '~/pages/art/factCard/libs/caption'
import { FactImageWrapper } from '~/pages/art/factCard/libs/imageWrapper'
import {
  ANSWERS,
  greenAccept,
  redCross,
} from '~/pages/onboarding/quizBinaryChoice/libs/constants'
import { Styles as S } from '~/pages/onboarding/quizBinaryChoice/libs/styles'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

const THE_SCREAM_QUESTION = `The Scream isn't screaming, it's hearing a scream.`

const TheScream = ({ nextPagePath, pageId }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: THE_SCREAM_QUESTION,
  })

  return (
    <PS.Root>
      <PS.StyledContainer>
        <FactImageWrapper>
          <picture>
            <source srcSet={theScreamWEBP} type="image/webp" />
            <img src={theScreamPNG} alt="The Scream" />
          </picture>
        </FactImageWrapper>

        <FactCaption>
          <Trans ns="art" i18nKey="onboarding.factCard.didYouKnow" />
        </FactCaption>

        <PS.Question>
          <Trans ns="art" i18nKey="onboarding.factCard.theScream.statement" />
        </PS.Question>

        <PS.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </PS.ButtonWrapper>
      </PS.StyledContainer>
    </PS.Root>
  )
}

export default TheScream
